import * as React from 'react'

import { Box, Section, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type LeaveTypeFormModel from 'modules/timeoff/lib/LeaveTypeForm'

import Approval from '../Content/Approval'

interface Props {
  leaveTypeForm: LeaveTypeFormModel
  canEditDetails: boolean
}

const ApprovalSection = ({ leaveTypeForm, canEditDetails }: Props) => {
  const handleApprovalRequiredChange = (value: boolean) => {
    leaveTypeForm.setValues({ approval_required: !value })
  }

  return (
    <Section
      illustration="calendar"
      title={i18n.t('settings.leave_types.page.approval.title')}
      description={i18n.t('settings.leave_types.page.approval.description')}
    >
      <Box gap="s8" extra={{ 'data-intercom-target': 'leave-type-approval-input' }}>
        <Approval
          readonly={!canEditDetails}
          field={leaveTypeForm.get('approval_required')}
          onChange={handleApprovalRequiredChange}
        />
        <Text.Normal size="100">
          {i18n.t('settings.leave_types.page.approval.form.approval_required.note')}
        </Text.Normal>
      </Box>
    </Section>
  )
}

export default ApprovalSection
